module.exports = __webpack_public_path__ + "static/img/platform02.97d9093.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/platform02.png
// module id = c0cf
// module chunks = 1